module.exports = __webpack_public_path__ + "static/media/landscape0.ac2e20b1.jpg";